module.exports = __webpack_public_path__ + "img/66.70771eec.jpg";